import React from "react";

export default function TapTrackLogo({ size = "default", showTagline = true, className = "" }) {
  const sizes = {
    small: { main: "text-lg", sub: "text-[10px]" },
    default: { main: "text-xl", sub: "text-xs" },
    large: { main: "text-2xl", sub: "text-sm" },
    xlarge: { main: "text-3xl", sub: "text-base" }
  };

  const { main, sub } = sizes[size] || sizes.default;

  return (
    <div className={`flex flex-col ${className}`} data-testid="taptrack-logo">
      <div className={`font-heading font-black ${main} text-slate-900 tracking-tight leading-tight`}>
        Engage
      </div>
      {showTagline && (
        <div className={`${sub} text-slate-400 font-medium tracking-wide`}>
          Powered by OCI
        </div>
      )}
    </div>
  );
}
